<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import EasySlider from "vue-easy-slider";
import Vue from "vue";
import moment from "moment";
import { debounce } from "../../../helpers/helper";
import vue2Dropzone from "vue2-dropzone";
import VueIframe from "vue-iframes";

Vue.use(EasySlider);
Vue.use(VueIframe);
//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    vueDropzone: vue2Dropzone,
    Layout,
  },
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      iframeWidth: "100%",
      iframeHeight: "100%",
      iframeScrolling: "auto",
      moment,
      isHidden: true,
      showSidebar: false,
      seen: true,
      active_el: 2,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      status: status == undefined ? "" : status,
      search: "",
      like_users: "",
      isActive: false,
      postDetail: "",
      planButton: false,
      financeSeen: false,
      publicationSeen: false,
      searchData: debounce((type) => {
        const { perPage, status, orderBy, sortBy } = this.$data;
        let id = this.$route.params.id;
        let page = 1;
        this.$router.replace({
          name: "company.show",
          params: { id: id },
          query: { perPage, status, orderBy, sortBy },
        });
        if (type == 1) {
          this.getPosts({
            page: page,
            perPage: this.perPage,
            search: this.search,
            status: this.status,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            id: id,
          });
        } else if (type == 2) {
          this.getEvent({
            page: page,
            perPage: this.perPage,
            search: this.search,
            status: this.status,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            id: id,
          });
        } else if (type == 3) {
          this.getFollowers({
            page: page,
            perPage: this.perPage,
            search: this.search,
            status: this.status,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            id: id,
          });
        } else {
          console.log("error");
        }
      }, 500),

      type: 1,
      url: process.env.VUE_APP_MIX_BASE_URL + "media/user/original/",
      company: {
        id: "",
        name: "",
        email: "",
        country_code: "",
        phone: "",
        password: "",
        short_about: "",
        about: "",
        website: "",
        finance: "",
        plan_count: "",
        plan_name: "",
        plan_id: "",
        image: "",
        image_path: "",
      },
      list: [
        {
          src: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/5689/rock.jpg",
          width: "100%",
          height: "100%",
        },
        {
          src: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/5689/grooves.jpg",
          width: "100%",
          height: "100%",
        },
        {
          src: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/5689/arch.jpg",
          width: "100%",
          height: "100%",
        },
      ],

      default_image: process.env.VUE_APP_MIX_BASE_URL + "images/download.png",
      user_image: process.env.VUE_APP_MIX_BASE_URL + "images/user.png",
      company_image: process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png",
      limit: 10,
      commentData: {
        comment: "",
      },
      commentSeen: false,
      perPage: perPage || 10,
      fields: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "post_description",
          label: this.$t("companyManagement.list.description"),
          sortable: true,
          tdClass: "w-75",
        },
        {
          key: "website_url",
          label: this.$t("companyManagement.list.websiteurl"),
          sortable: true,
          tdClass: "w-75",
        },
        {
          key: "is_active",
          label: this.$t("userManagement.list.status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.$t("userManagement.list.action"),
          sortable: false,
        },
      ],
      eventsData: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$t("userManagement.list.name"),
          sortable: true,
          tdClass: "w-75",
        },
        {
          key: "is_active",
          label: this.$t("userManagement.list.status"),
          sortable: false,
        },
      ],
      financeDropzoneOptions: {
        url:
          process.env.VUE_APP_MIX_URL + "/admin/finance-create/" + this.$route.params.id,
        thumbnailWidth: 150,
        headers: window.axios.defaults.headers.common,
        maxFiles: 5,
        maxFileSize: 200,
        acceptedFiles: ".pdf",
        uploadMultiple: false,
        addRemoveLinks: true,
        success: (response) => {
          if (response.status == "success") {
            const data = JSON.parse(response.xhr.response);

            this.baseUrl = data.base_url;
            this.files = this.multiple ? [...this.files, data.file] : data.file;
            const id = this.$route.params.id;
            let page = 1;
            this.getFinanceFile({
              page: page,
              perPage: this.perPage,
              search: this.search,
              status: this.status,
              sortBy: this.sortBy,
              orderBy: this.sortDesc ? "desc" : "asc",
              id: id,
            });
            // this.$emit('input', this.multiple ? [...this.value?this.value:[], data.file] : [data.file]);
          }
        },
        error: function (file) {
          console.log(file);
        },
      },
      governanceDropzoneOptions: {
        url:
          process.env.VUE_APP_MIX_URL +
          "/admin/governance-create/" +
          this.$route.params.id,
        thumbnailWidth: 150,
        headers: window.axios.defaults.headers.common,
        maxFiles: 5,
        acceptedFiles: ".pdf",
        uploadMultiple: false,
        addRemoveLinks: true,
        success: (response) => {
          if (response.status == "success") {
            const data = JSON.parse(response.xhr.response);

            this.baseUrl = data.base_url;
            this.files = this.multiple ? [...this.files, data.file] : data.file;
            const id = this.$route.params.id;
            let page = 1;
            this.getGovernanceFile({
              page: page,
              perPage: this.perPage,
              search: this.search,
              status: this.status,
              sortBy: this.sortBy,
              orderBy: this.sortDesc ? "desc" : "asc",
              id: id,
            });
            // this.$emit('input', this.multiple ? [...this.value?this.value:[], data.file] : [data.file]);
          }
        },
        error: function (file) {
          console.log(file);
        },
      },
    };
  },
  computed: mapGetters("company", [
    "loading",
    "companyCount",
    "companyData",
    "paginations",
    "events",
    "followers",
    "posts",
    "companies",
    "postData",
    "financeFiles",
    "publicationFiles",
    "governanceFiles",
    "followerCount",
  ]),
  mounted() {
    let id = this.$route.params.id;
    this.showCompanyName(id);
    let page = 1;
    let orderBy = this.sortDesc ? "desc" : "asc";
    this.getPosts({
      page: page,
      perPage: this.perPage,
      search: this.search,
      status: this.status,
      sortBy: this.sortBy,
      orderBy: orderBy,
      id: id,
    });
  },
  methods: {
    ...mapActions("company", [
      "showCompany",
      "updateCompany",
      "deletePost",
      "getEvent",
      "getFollowers",
      "getPosts",
      "getFinanceFile",
      "getPublicationFile",
      "getGovernanceFile",
      "deleteGovernance",
      "deleteFinance",
      "unsubscribePlan",
    ]),
    ...mapActions("post", ["showPost", "deletePost", "createComment", "likePost"]),
    showCompanyName(id) {
      this.showCompany(id).then((res) => {
        console.log("res", res);
        this.company.id = res.data.id;
        this.company.name = res.data.name;
        this.company.email = res.data.email;
        this.company.country_code = res.data.country_code;
        this.company.phone = res.data.phone_number;
        this.company.short_about = res.data.short_description;
        this.company.about = res.data.description;
        this.company.website = res.data.website;
        this.company.plan_count = res.data.plan_count;
        if (res.data.plan_count > 0) {
          if (res.data.plan_detail.name == "Company Investor Relations Account") {
            this.financeSeen = true;
            this.publicationSeen = false;
          } else {
            this.financeSeen = false;
            this.publicationSeen = true;
          }

          if (res.data.plan_detail.pay_status == "Paid") {
            this.planButton = true;
          } else {
            this.planButton = false;
          }
        } else {
          this.planButton = false;
          this.financeSeen = true;
          this.publicationSeen = false;
        }
        this.company.plan_id = res.data.plan_detail ? res.data.plan_detail.id : "";
        this.company.plan_name = res.data.plan_detail ? res.data.plan_detail.name : "";
        this.company.image = res.data.image;
        this.company.image_path = res.data.image_original_url;
      });
    },

    post(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getPosts({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
      this.type = 1;
    },
    showComments() {
      console.log("id");
    },
    activate: function (el) {
      this.active_el = el;
    },

    getToggelData(id) {
      this.showPost(id).then((res) => {
        this.like_users = res.data.like_users
          .concat(res.data.like_companies)
          .concat(res.data.like_admin);
        this.showSidebar = !this.showSidebar;
      });
      //  document.body.classList.toggle("right-bar-enabled");
    },
    editPostName(id) {
      this.$router.push({ name: "company.post.edit", params: { id: id } });
    },
    deletePostName(id) {
      if (confirm("Do you really want to delete?")) {
        this.deletePost(id).then((res) => {
          if (res.success) {
            window.location.reload();
          }
        });
      }
    },
    showPostDetail(id) {
      console.log("dfsdf", id);
      this.commentSeen = false;
      this.showPost(id).then((res) => {
        console.log("res", res);
        this.postDetail = res.data;
      });
    },

    event(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getEvent({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
      this.type = 2;
    },
    follower(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getFollowers({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
      this.type = 3;
    },
    finance(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getFinanceFile({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
    },
    publication(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getPublicationFile({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
    },
    governance(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getGovernanceFile({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
    },
    userDetails(id) {
      this.$router.push({ name: "user.detail", params: { id: id } });
    },
    afterUploadComplete: async function (response) {
      if (response.status == "success") {
        console.log("success");
      } else {
        console.log("fail");
      }
    },
    deleteGovernanceFile(id) {
      if (confirm("Are you sure want to delete?")) {
        this.deleteGovernance(id).then((res) => {
          if (res) window.location.reload();
        });
      }
    },
    deleteFinanceFile(id) {
      if (confirm("Are you sure want to delete?")) {
        this.deleteFinance(id).then((res) => {
          if (res) window.location.reload();
        });
      }
    },
    deletePublicationFile(id) {
      if (confirm("Are you sure want to delete?")) {
        this.deletePublication(id).then((res) => {
          if (res) window.location.reload();
        });
      }
    },
    hideData() {
      this.post(1);
      this.commentSeen = false;
      this.isHidden = !this.isHidden;
      this.showSidebar = this.showSidebar;
    },
    imageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/download.png";
    },
    userimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/user.png";
    },
    companyimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png";
    },
    unsubscribe(companyId) {
      this.unsubscribePlan(companyId).then((res) => {
        if (res) {
          this.company.plan_name = "";
          this.planButton = false;
          this.financeSeen = true;
          this.publicationSeen = false;
        }
      });
    },
    onLoad(frame) {
      this.myIframe = frame.contentWindow;
    },
    create(post_id) {
      if (this.commentData.comment) {
        this.isActive = true;
        var data = { ...this.commentData, id: post_id };

        this.createComment(data).then((res) => {
          if (res) this.commentData.comment = "";
          this.hideData();
        });
      }
    },

    likes(post_id) {
      this.likePost(post_id).then((res) => {
        if (res.success) {
          this.post(1);
        }
      });
    },
    comments(postId) {
      this.commentSeen = !this.commentSeen;
      this.showPost(postId).then((res) => {
        this.postDetail = res.data;
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon" style="display: flex">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ company.name }}</h4>
              <p>
                <router-link :to="{ name: 'company.list' }">Company</router-link>
                > {{ company.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-lg-8 col-xl-9">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <input type="hidden" class="form-control" name="id" v-model="company.id" />
              <div class="col-12 mb-2">
                <div class="form-group" style="display: flex; align-items: center">
                  <a :href="company.image_path" target="_blank" v-if="company.image"
                    ><img :src="company.image_path" width="80" height="80"
                  /></a>
                  <a :href="company_image" target="_blank" v-else
                    ><img :src="company_image" width="80" height="80"
                  /></a>
                  <div
                    style="
                      display: flex;
                      align-items: flex-start;
                      flex-direction: column;
                      margin-left: 20px;
                    "
                  >
                    <h4 style="margin-bottom: auto !important">
                      <span> {{ company.name }} </span>
                    </h4>
                    <span class="text-muted">{{ company.email }}</span
                    ><span class="text-muted" v-if="company.country_code && company.phone"
                      >{{ company.country_code }} {{ company.phone }}</span
                    ><a :href="company.website" target="_blank"
                      ><span>{{ company.website }}</span></a
                    >

                    <!-- <router-link
                      :to="{ name: 'company.edit', params: { id: company.id } }"
                      class="btn btn-danger btn-rounded mr-2 edit-btn"
                    >
                      Unsubscribe
                    </router-link> -->
                  </div>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      margin-left: auto;
                      margin-bottom: auto;
                    "
                  >
                    <div style="display: flex; flex-direction: column">
                      <h6>Current Active Plan</h6>
                      <span v-if="company.plan_name">{{ company.plan_name }}</span>
                      <span v-else>-</span>
                    </div>
                    <div style="display: flex; flex-direction: column">
                      <button
                        class="btn btn-danger btn-rounded"
                        @click="unsubscribe(company.id)"
                        v-if="company.plan_count > 0 && planButton"
                      >
                        Unsubscribe
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-2">
                <b-tabs content-class="mt-3" nav-class="nav-tabs-custom">
                  <b-tab title="Posts" active @click="post">
                    <div class="row list-table-main">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="justify-content-center row" v-if="isHidden">
                              <div class="col-xl-11">
                                <div>
                                  <div class="align-items-center row">
                                    <div class="col-4">
                                      <div>
                                        <h5 class="mb-0">All Post</h5>
                                      </div>
                                    </div>
                                    <div class="col-8">
                                      <div>
                                        <ul class="nav nav-pills justify-content-end">
                                          <li class="nav-item">
                                            <a
                                              class="nav-link"
                                              href="#"
                                              v-on:click="seen = false"
                                              @click="activate(1)"
                                              :class="{ active: active_el == 1 }"
                                            >
                                              <i class="mdi mdi-format-list-bulleted"></i>
                                            </a>
                                          </li>
                                          <li class="nav-item">
                                            <a
                                              class="nav-link"
                                              href="#"
                                              v-on:click="seen = true"
                                              @click="activate(2)"
                                              :class="{ active: active_el == 2 }"
                                            >
                                              <i class="mdi mdi-view-grid-outline"></i>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                  <hr class="mb-4" />
                                  <div v-if="posts.total > 0">
                                    <div class="row" v-if="seen">
                                      <div
                                        class="col-sm-6"
                                        v-for="post in posts.data"
                                        :key="post.id"
                                      >
                                        <div class="p-1 border shadow-none card">
                                          <div class="p-3">
                                            <div
                                              style="
                                                display: flex;
                                                align-items: center;
                                                width: 100% !important;
                                                justify-content: space-between;
                                              "
                                            >
                                              <div
                                                style="display: flex; align-items: center"
                                              >
                                                <b-avatar
                                                  variant="info"
                                                  :src="company.image_path"
                                                  class="mr-3"
                                                  v-if="company.image"
                                                ></b-avatar>
                                                <b-avatar
                                                  variant="info"
                                                  :src="company_image"
                                                  class="mr-3"
                                                  v-else
                                                ></b-avatar>
                                                <div style="display: grid">
                                                  <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  >
                                                    <span class="font-size-15 mr-auto">{{
                                                      company.name
                                                    }}</span>
                                                  </a>

                                                  <small
                                                    v-if="post.created_at"
                                                    class="text-muted"
                                                    >{{
                                                      moment(post.created_at).fromNow()
                                                    }}</small
                                                  >
                                                  <small v-else class="text-muted"
                                                    >-</small
                                                  >
                                                </div>
                                              </div>
                                              <b-dropdown
                                                class="float-right ml-5"
                                                toggle-class="text-muted p-0"
                                                right
                                                variant="white"
                                              >
                                                <template v-slot:button-content>
                                                  <i
                                                    class="mdi mdi-dots-horizontal font-size-18"
                                                  ></i>
                                                </template>
                                                <b-dropdown-item
                                                  @click="editPostName(post.id)"
                                                  v-if="
                                                    !post.repost_id && !post.parent_post
                                                  "
                                                  >Edit</b-dropdown-item
                                                >
                                                <b-dropdown-item
                                                  @click="deletePostName(post.id)"
                                                  >Delete</b-dropdown-item
                                                >
                                              </b-dropdown>
                                              <!-- <button class="btn" @click="editPostName(post.id)"><i class="bx bx-pencil" aria-hidden="true"></i></button>
                                                  <button class="btn" @click="deletePostName(post.id)"><i class="bx bx-trash"></i></button> -->
                                            </div>
                                          </div>
                                          <input type="hidden" :value="post.id" />
                                          <div v-if="!post.repost_id">
                                            <div class="pt-3 pb-2 pl-3">
                                              <div
                                                v-html="post.post_description"
                                                id="app"
                                                style="white-space: pre-wrap"
                                                class="text-dark"
                                                v-on:click="isHidden = false"
                                                @click="showPostDetail(post.id)"
                                                v-if="post.post_description.length < 500"
                                              ></div>

                                              <div
                                                v-html="
                                                  post.post_description.substring(
                                                    0,
                                                    500
                                                  ) + '..'
                                                "
                                                id="app"
                                                style="white-space: pre-wrap"
                                                class="text-dark"
                                                v-on:click="isHidden = false"
                                                @click="showPostDetail(post.id)"
                                                v-else
                                              ></div>

                                              <div
                                                v-if="post.post_description.length > 500"
                                                class="mb-2"
                                              >
                                                <span
                                                  v-on:click="isHidden = false"
                                                  @click="showPostDetail(post.id)"
                                                  >Read more
                                                  <i class="mdi mdi-arrow-right"></i
                                                ></span>
                                              </div>
                                            </div>

                                            <div
                                              v-if="
                                                post.website_url ||
                                                post.posts_images.length > 0
                                              "
                                            >
                                              <div
                                                class="position-relative ml-4"
                                                v-if="post.website_url"
                                              >
                                                <div class="repost-border1">
                                                  <a
                                                    :href="post.website_url"
                                                    class="text-primary"
                                                    target="_blank"
                                                  >
                                                    <div
                                                      class=""
                                                      style="width: 100% !important"
                                                    >
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                          width: 100% !important;
                                                          justify-content: space-between;
                                                        "
                                                      >
                                                        <div
                                                          style="
                                                            display: flex;
                                                            align-items: center;
                                                          "
                                                        >
                                                          <img
                                                            :src="
                                                              post.website_detail
                                                                .website_image
                                                            "
                                                            alt=""
                                                            v-if="
                                                              post.website_detail
                                                                .website_image
                                                            "
                                                            style="
                                                              width: 100% !important;
                                                              object-fit: cover;
                                                            "
                                                            @error="companyimageNotFound"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div
                                                        style="
                                                          background-color: #e8e8e8;
                                                          width: 100% !important;
                                                          object-fit: cover;
                                                          padding: 10px;
                                                        "
                                                      >
                                                        <span
                                                          style="color: #000"
                                                          class="text-dark"
                                                          v-if="
                                                            post.website_detail
                                                              .website_title
                                                          "
                                                        >
                                                          <h6>
                                                            {{
                                                              post.website_detail
                                                                .website_title
                                                            }}
                                                          </h6>
                                                        </span>
                                                        <span
                                                          style="color: #000"
                                                          class="text-dark"
                                                          v-if="
                                                            post.website_detail
                                                              .website_description
                                                          "
                                                        >
                                                          {{
                                                            post.website_detail
                                                              .website_description
                                                          }}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </a>
                                                </div>
                                              </div>
                                              <div class="position-relative" v-else>
                                                <div v-if="post.posts_images.length > 1">
                                                  <slider
                                                    animation="fade"
                                                    style="width: 100% !important"
                                                  >
                                                    <slider-item
                                                      v-for="index in post.posts_images"
                                                      :key="index"
                                                    >
                                                      <!-- @click="hello" -->
                                                      <a
                                                        class="text-dark"
                                                        href="#"
                                                        v-on:click="isHidden = false"
                                                        @click="showPostDetail(post.id)"
                                                      >
                                                        <img
                                                          :src="
                                                            index.image_path +
                                                            '/' +
                                                            index.image
                                                          "
                                                          style="
                                                            height: 300px !important;
                                                            width: 100% !important;
                                                            object-fit: cover;
                                                          "
                                                          @error="imageNotFound"
                                                        />
                                                      </a>
                                                    </slider-item>
                                                  </slider>
                                                </div>
                                                <div
                                                  v-else-if="
                                                    post.posts_images.length == 1
                                                  "
                                                >
                                                  <!-- <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  > -->
                                                  <img
                                                    :src="
                                                      post.posts_images[0].image_path +
                                                      '/' +
                                                      post.posts_images[0].image
                                                    "
                                                    alt=""
                                                    v-if="
                                                      post.posts_images[0].type == 'Image'
                                                    "
                                                    class="img-thumbnail"
                                                    style="
                                                      height: auto !important;
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                    "
                                                    @error="imageNotFound"
                                                  />
                                                  <video
                                                    style="
                                                      height: auto !important;
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                    "
                                                    v-if="
                                                      post.posts_images[0].type == 'Video'
                                                    "
                                                    controls
                                                    :src="
                                                      post.posts_images[0].image_path +
                                                      '/' +
                                                      post.posts_images[0].image
                                                    "
                                                  ></video>

                                                  <div
                                                    class="embed-responsive embed-responsive-16by9"
                                                    v-if="
                                                      post.posts_images[0].type == 'File'
                                                    "
                                                  >
                                                    <iframe
                                                      class="embed-responsive-item"
                                                      :src="
                                                        post.posts_images[0].image_path +
                                                        '/' +
                                                        post.posts_images[0].image
                                                      "
                                                    ></iframe>
                                                  </div>

                                                  <!-- <span
                                                    v-if="
                                                      post.posts_images[0].type == 'File'
                                                    "
                                                    >{{ post.posts_images[0].image }}</span
                                                  > -->
                                                  <!-- </a> -->
                                                </div>
                                                <div v-else>
                                                  <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  >
                                                    <img
                                                      :src="default_image"
                                                      alt=""
                                                      class="img-thumbnail"
                                                      style="
                                                        height: auto !important;
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                      "
                                                    />
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                            <div v-else></div>
                                            <div class="pl-3 pr-2 pt-3">
                                              <ul
                                                class="list-inline"
                                                style="
                                                  display: flex;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <li class="list-inline-item">
                                                  <a
                                                    class="text-muted"
                                                    href="javascript:void(0)"
                                                    @click="getToggelData(post.id)"
                                                  >
                                                    <i
                                                      class="bx bx-like align-middle text-muted me-1"
                                                    ></i>
                                                    {{
                                                      post.like_users.length +
                                                      post.like_companies.length +
                                                      post.like_admin.length
                                                    }}
                                                    Likes
                                                  </a>
                                                </li>
                                                <li class="list-inline-item">
                                                  <a
                                                    class="text-muted"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  >
                                                    <i
                                                      class="bx bx-comment-dots align-middle text-muted me-1"
                                                    ></i>
                                                    {{ post.comments.length }} Comments
                                                  </a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <div class="pl-2 pr-2" v-else>
                                            <div
                                              v-if="post.repost_id && post.parent_post"
                                            >
                                              <div class="repost-border pr-2 pl-2">
                                                <a
                                                  class="text-dark"
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="
                                                    showPostDetail(post.parent_post.id)
                                                  "
                                                >
                                                  <div class="p-3">
                                                    <div
                                                      style="
                                                        display: flex;
                                                        align-items: center;
                                                        width: 100% !important;
                                                        justify-content: space-between;
                                                      "
                                                    >
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                        "
                                                        v-if="
                                                          post.parent_post.company &&
                                                          post.parent_post.is_company == 1
                                                        "
                                                      >
                                                        <b-avatar
                                                          variant="info"
                                                          :src="
                                                            post.parent_post.company
                                                              .image_path +
                                                            '/' +
                                                            post.parent_post.company.image
                                                          "
                                                          class="mr-3"
                                                          v-if="
                                                            post.parent_post.company.image
                                                          "
                                                        ></b-avatar>
                                                        <b-avatar
                                                          variant="info"
                                                          :src="company_image"
                                                          class="mr-3"
                                                          v-else
                                                        ></b-avatar>
                                                        <div style="display: grid">
                                                          <span
                                                            class="font-size-15 mr-auto text-dark"
                                                            >{{
                                                              post.parent_post.company
                                                                .name
                                                            }}</span
                                                          >

                                                          <small
                                                            v-if="
                                                              post.parent_post.created_at
                                                            "
                                                            class="text-muted"
                                                            >{{
                                                              moment(
                                                                post.parent_post
                                                                  .created_at
                                                              ).fromNow()
                                                            }}
                                                          </small>
                                                          <small v-else class="text-muted"
                                                            >-</small
                                                          >
                                                        </div>
                                                      </div>

                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                        "
                                                        v-if="
                                                          post.parent_post.user &&
                                                          post.parent_post.is_company == 0
                                                        "
                                                      >
                                                        <b-avatar
                                                          variant="info"
                                                          :src="
                                                            post.parent_post.user
                                                              .image_url
                                                          "
                                                          class="mr-3"
                                                          v-if="
                                                            post.parent_post.user.image
                                                          "
                                                        ></b-avatar>
                                                        <b-avatar
                                                          variant="info"
                                                          :src="user_image"
                                                          class="mr-3"
                                                          v-else
                                                        ></b-avatar>

                                                        <div style="display: grid">
                                                          <span
                                                            class="font-size-15 mr-auto text-dark"
                                                            >{{
                                                              post.parent_post.user.name
                                                            }}</span
                                                          >

                                                          <small
                                                            v-if="
                                                              post.parent_post.created_at
                                                            "
                                                            class="text-muted"
                                                            >{{
                                                              moment(
                                                                post.parent_post
                                                                  .created_at
                                                              ).fromNow()
                                                            }}</small
                                                          >
                                                          <small v-else class="text-muted"
                                                            >-</small
                                                          >
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="pl-3 pr-3">
                                                    <div
                                                      v-html="
                                                        post.parent_post.post_description
                                                      "
                                                      id="app"
                                                      style="white-space: pre-wrap"
                                                      class="text-dark"
                                                      v-if="
                                                        post.parent_post.post_description
                                                          .length < 500
                                                      "
                                                    ></div>

                                                    <div
                                                      v-html="
                                                        post.parent_post.post_description.substring(
                                                          0,
                                                          500
                                                        ) + '..'
                                                      "
                                                      id="app"
                                                      style="white-space: pre-wrap"
                                                      class="text-dark pt-3"
                                                      v-else
                                                    ></div>
                                                    <div
                                                      v-if="
                                                        post.parent_post.post_description
                                                          .length > 500
                                                      "
                                                      class="mb-2"
                                                    >
                                                      <router-link
                                                        :to="{
                                                          name: 'company.newsfeeds.show',
                                                          params: { id: post.id },
                                                        }"
                                                        class="text-primary"
                                                        >Read more
                                                        <i class="mdi mdi-arrow-right"></i
                                                      ></router-link>
                                                    </div>

                                                    <div
                                                      v-if="
                                                        post.parent_post.website_url ||
                                                        post.parent_post.posts_images
                                                          .length > 0
                                                      "
                                                    >
                                                      <div
                                                        class="position-relative mb-3 mt-3"
                                                        v-if="
                                                          post.parent_post.website_url
                                                        "
                                                      >
                                                        <div class="repost-border1">
                                                          <a
                                                            :href="
                                                              post.parent_post.website_url
                                                            "
                                                            class="text-primary"
                                                            target="_blank"
                                                          >
                                                            <div
                                                              class=""
                                                              style="
                                                                width: 100% !important;
                                                              "
                                                            >
                                                              <div
                                                                style="
                                                                  display: flex;
                                                                  align-items: center;
                                                                  width: 100% !important;
                                                                  justify-content: space-between;
                                                                "
                                                              >
                                                                <div
                                                                  style="
                                                                    display: flex;
                                                                    align-items: center;
                                                                  "
                                                                >
                                                                  <img
                                                                    :src="
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_image
                                                                    "
                                                                    alt=""
                                                                    v-if="
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_image
                                                                    "
                                                                    style="
                                                                      width: 100% !important;
                                                                      object-fit: cover;
                                                                    "
                                                                    @error="
                                                                      companyimageNotFound
                                                                    "
                                                                  />
                                                                </div>
                                                              </div>
                                                              <div
                                                                style="
                                                                  background-color: #e8e8e8;
                                                                  width: 100% !important;
                                                                  object-fit: cover;
                                                                  padding: 10px;
                                                                "
                                                              >
                                                                <span
                                                                  style="color: #000"
                                                                  class="text-dark"
                                                                  v-if="
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_title
                                                                  "
                                                                >
                                                                  <h6>
                                                                    {{
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_title
                                                                    }}
                                                                  </h6>
                                                                </span>
                                                                <span
                                                                  style="color: #000"
                                                                  class="text-dark"
                                                                  v-if="
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_description
                                                                  "
                                                                >
                                                                  {{
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_description
                                                                  }}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </a>
                                                        </div>
                                                      </div>
                                                      <div
                                                        class="position-relative mb-3 mt-3"
                                                        v-else
                                                      >
                                                        <div
                                                          v-if="
                                                            post.parent_post.posts_images
                                                              .length > 1
                                                          "
                                                        >
                                                          <slider
                                                            animation="fade"
                                                            height="400px"
                                                            width="auto"
                                                          >
                                                            <slider-item
                                                              v-for="(
                                                                image, index
                                                              ) in post.parent_post
                                                                .posts_images"
                                                              :key="index"
                                                            >
                                                              <img
                                                                :src="
                                                                  image.image_path +
                                                                  '/' +
                                                                  image.image
                                                                "
                                                                width="665px;"
                                                                style="
                                                                  height: 400px !important;
                                                                "
                                                                @error="imageNotFound"
                                                              />
                                                            </slider-item>
                                                          </slider>
                                                        </div>
                                                        <div
                                                          v-else-if="
                                                            post.parent_post.posts_images
                                                              .length == 1
                                                          "
                                                        >
                                                          <video
                                                            style="
                                                              height: auto !important;
                                                              width: 100% !important;
                                                              object-fit: cover;
                                                            "
                                                            v-if="
                                                              post.parent_post
                                                                .posts_images[0].type ==
                                                              'Video'
                                                            "
                                                            controls
                                                            :src="
                                                              post.parent_post
                                                                .posts_images[0]
                                                                .image_path +
                                                              '/' +
                                                              post.parent_post
                                                                .posts_images[0].image
                                                            "
                                                          ></video>

                                                          <img
                                                            :src="
                                                              post.parent_post
                                                                .posts_images[0]
                                                                .image_path +
                                                              '/' +
                                                              post.parent_post
                                                                .posts_images[0].image
                                                            "
                                                            alt=""
                                                            v-if="
                                                              post.parent_post
                                                                .posts_images[0].type ==
                                                              'Image'
                                                            "
                                                            class="img-thumbnail"
                                                            width="100%"
                                                            @error="imageNotFound"
                                                          />
                                                          <!-- style="
                                                              height: 400px !important;
                                                              width: 100% !important;
                                                            " -->
                                                          <div
                                                            class="embed-responsive embed-responsive-16by9"
                                                            v-if="
                                                              post.parent_post
                                                                .posts_images[0].type ==
                                                              'File'
                                                            "
                                                          >
                                                            <iframe
                                                              class="embed-responsive-item vue_frame"
                                                              :src="
                                                                post.parent_post
                                                                  .posts_images[0]
                                                                  .image_path +
                                                                '/' +
                                                                post.parent_post
                                                                  .posts_images[0].image
                                                              "
                                                            ></iframe>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div v-else></div>
                                                    <ul
                                                      class="list-inline"
                                                      style="
                                                        display: flex;
                                                        justify-content: space-between;
                                                      "
                                                    >
                                                      <li class="list-inline-item">
                                                        <i
                                                          class="bx bx-like align-middle text-muted me-1"
                                                        ></i>

                                                        {{
                                                          post.parent_post.like_admin
                                                            .length +
                                                          post.parent_post.like_companies
                                                            .length +
                                                          post.parent_post.like_users
                                                            .length
                                                        }}
                                                        Likes
                                                      </li>
                                                      <li class="list-inline-item">
                                                        <i
                                                          class="bx bx-comment-dots align-middle text-muted me-1"
                                                        ></i>
                                                        {{
                                                          post.parent_post.comments.length
                                                        }}
                                                        Comments
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </a>
                                              </div>
                                              <ul
                                                class="list-inline mt-3 mb-0"
                                                style="
                                                  display: flex;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <li class="list-inline-item">
                                                  <a
                                                    class="text-muted"
                                                    href="javascript:void(0)"
                                                    @click="getToggelData(post.id)"
                                                    ><i
                                                      class="bx bx-like align-middle text-muted me-1"
                                                    ></i>
                                                    {{
                                                      post.like_users.length +
                                                      post.like_companies.length +
                                                      post.like_admin.length
                                                    }}
                                                    Likes</a
                                                  >
                                                </li>
                                                <li class="list-inline-item">
                                                  <a
                                                    class="text-muted"
                                                    :href="'/company/show/' + post.id"
                                                  >
                                                    <i
                                                      class="bx bx-comment-dots align-middle text-muted me-1"
                                                    ></i>
                                                    {{ post.comments.length }} Comments</a
                                                  >
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <hr class="my-1" />
                                          <div class="pl-3 pr-3 pt-2">
                                            <ul
                                              class="list-inline text-muted"
                                              style="
                                                display: flex;
                                                justify-content: space-between;
                                              "
                                            >
                                              <li
                                                class="list-inline-item w-50 likes-post"
                                                v-if="post.like_admin.length > 0"
                                                style="text-align: center"
                                              >
                                                <a
                                                  @click="likes(post.id)"
                                                  class="text-muted"
                                                  href="javascript:void(0)"
                                                >
                                                  <i
                                                    class="bx bxs-like align-middle text-muted me-1 bx-sm"
                                                  ></i>
                                                </a>
                                              </li>
                                              <li
                                                class="list-inline-item w-50 likes-post"
                                                v-else
                                                style="text-align: center"
                                              >
                                                <a
                                                  @click="likes(post.id)"
                                                  class="text-muted"
                                                  href="javascript:void(0)"
                                                >
                                                  <i
                                                    class="bx bx-like align-middle text-muted me-1 bx-sm"
                                                  ></i>
                                                </a>
                                              </li>

                                              <li
                                                class="list-inline-item w-50"
                                                style="text-align: center"
                                              >
                                                <a
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="comments(post.id)"
                                                  class="text-muted"
                                                >
                                                  <i
                                                    class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                                                  ></i>
                                                </a>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row" v-else>
                                      <div
                                        class="col-sm-12"
                                        v-for="post in posts.data"
                                        :key="post.id"
                                      >
                                        <div
                                          style="
                                            display: flex;
                                            align-items: center;
                                            width: 100% !important;
                                            justify-content: space-between;
                                          "
                                        >
                                          <div style="display: flex; align-items: center">
                                            <b-avatar
                                              variant="info"
                                              :src="company.image_path"
                                              class="mr-3"
                                              v-if="company.image"
                                            ></b-avatar>
                                            <b-avatar
                                              variant="info"
                                              :src="company_image"
                                              class="mr-3"
                                              v-else
                                            ></b-avatar>

                                            <div style="display: grid">
                                              <a
                                                class="text-dark"
                                                href="#"
                                                v-on:click="isHidden = false"
                                                @click="showPostDetail(post.id)"
                                              >
                                                <span class="font-size-15 mr-auto">{{
                                                  company.name
                                                }}</span>
                                              </a>

                                              <small
                                                v-if="post.created_at"
                                                class="text-muted"
                                                >{{ moment(post.created_at).fromNow() }}
                                              </small>
                                              <small v-else class="text-muted">-</small>
                                            </div>
                                          </div>
                                          <b-dropdown
                                            class="float-right ml-5"
                                            toggle-class="text-muted p-0"
                                            right
                                            variant="white"
                                          >
                                            <template v-slot:button-content>
                                              <i
                                                class="mdi mdi-dots-horizontal font-size-18"
                                              ></i>
                                            </template>
                                            <b-dropdown-item
                                              @click="editPostName(post.id)"
                                              v-if="!post.repost_id && !post.parent_post"
                                              >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                              @click="deletePostName(post.id)"
                                              >Delete</b-dropdown-item
                                            >
                                          </b-dropdown>
                                        </div>
                                        <input type="hidden" :value="post.id" />
                                        <div v-if="!post.repost_id">
                                          <div class="p-2">
                                            <div
                                              v-html="post.post_description"
                                              id="app"
                                              style="white-space: pre-wrap"
                                              class="text-dark"
                                              v-on:click="isHidden = false"
                                              @click="showPostDetail(post.id)"
                                              v-if="post.post_description.length < 500"
                                            ></div>

                                            <div
                                              v-html="
                                                post.post_description.substring(0, 500) +
                                                '..'
                                              "
                                              id="app"
                                              style="white-space: pre-wrap"
                                              class="text-dark"
                                              v-on:click="isHidden = false"
                                              @click="showPostDetail(post.id)"
                                              v-else
                                            ></div>

                                            <div
                                              v-if="post.post_description.length > 500"
                                              class="mb-2"
                                            >
                                              <span
                                                v-on:click="isHidden = false"
                                                @click="showPostDetail(post.id)"
                                                >Read more
                                                <i class="mdi mdi-arrow-right"></i
                                              ></span>
                                            </div>
                                          </div>

                                          <div
                                            v-if="
                                              post.website_url ||
                                              post.posts_images.length > 0
                                            "
                                          >
                                            <div
                                              class="position-relative ml-2 mr-2 mb-2"
                                              v-if="post.website_url"
                                            >
                                              <div class="repost-border1">
                                                <a
                                                  :href="post.website_url"
                                                  class="text-primary"
                                                  target="_blank"
                                                >
                                                  <div
                                                    class=""
                                                    style="width: 100% !important"
                                                  >
                                                    <div
                                                      style="
                                                        display: flex;
                                                        align-items: center;
                                                        width: 100% !important;
                                                        justify-content: space-between;
                                                      "
                                                    >
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                        "
                                                      >
                                                        <img
                                                          :src="
                                                            post.website_detail
                                                              .website_image
                                                          "
                                                          alt=""
                                                          v-if="
                                                            post.website_detail
                                                              .website_image
                                                          "
                                                          style="
                                                            width: 100% !important;
                                                            object-fit: cover;
                                                          "
                                                          @error="companyimageNotFound"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div
                                                      style="
                                                        background-color: #e8e8e8;
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                        padding: 10px;
                                                      "
                                                    >
                                                      <span
                                                        style="color: #000"
                                                        class="text-dark"
                                                        v-if="
                                                          post.website_detail
                                                            .website_title
                                                        "
                                                      >
                                                        <h6>
                                                          {{
                                                            post.website_detail
                                                              .website_title
                                                          }}
                                                        </h6>
                                                      </span>
                                                      <span
                                                        style="color: #000"
                                                        class="text-dark"
                                                        v-if="
                                                          post.website_detail
                                                            .website_description
                                                        "
                                                      >
                                                        {{
                                                          post.website_detail
                                                            .website_description
                                                        }}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </a>
                                              </div>
                                            </div>

                                            <div class="position-relative" v-else>
                                              <div v-if="post.posts_images.length > 1">
                                                <slider
                                                  animation="fade"
                                                  style="width: 100% !important"
                                                >
                                                  <slider-item
                                                    v-for="index in post.posts_images"
                                                    :key="index"
                                                  >
                                                    <!-- <a
                                                      class="text-dark"
                                                      href="#"
                                                      v-on:click="isHidden = false"
                                                      @click="showPostDetail(post.id)"
                                                    > -->
                                                    <img
                                                      :src="
                                                        index.image_path +
                                                        '/' +
                                                        index.image
                                                      "
                                                      style="
                                                        height: 300px !important;
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                      "
                                                      @error="imageNotFound"
                                                    />
                                                    <!-- </a> -->
                                                  </slider-item>
                                                </slider>
                                              </div>
                                              <div
                                                v-else-if="post.posts_images.length == 1"
                                              >
                                                <!-- <a
                                                  class="text-dark"
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="showPostDetail(post.id)"
                                                > -->
                                                <img
                                                  v-if="
                                                    post.posts_images[0].type == 'Image'
                                                  "
                                                  :src="
                                                    post.posts_images[0].image_path +
                                                    '/' +
                                                    post.posts_images[0].image
                                                  "
                                                  alt=""
                                                  class="img-thumbnail"
                                                  style="
                                                    height: auto !important;
                                                    width: 100% !important;
                                                    object-fit: cover;
                                                  "
                                                  @error="imageNotFound"
                                                />
                                                <video
                                                  style="
                                                    height: auto !important;
                                                    width: 100% !important;
                                                    object-fit: cover;
                                                  "
                                                  v-if="
                                                    post.posts_images[0].type == 'Video'
                                                  "
                                                  controls
                                                  :src="
                                                    post.posts_images[0].image_path +
                                                    '/' +
                                                    post.posts_images[0].image
                                                  "
                                                ></video>

                                                <div
                                                  class="embed-responsive embed-responsive-16by9"
                                                  v-if="
                                                    post.posts_images[0].type == 'File'
                                                  "
                                                  style="margin-bottom: -115px !important"
                                                >
                                                  <iframe
                                                    class="embed-responsive-item vue_frame"
                                                    :src="
                                                      post.posts_images[0].image_path +
                                                      '/' +
                                                      post.posts_images[0].image
                                                    "
                                                  ></iframe>
                                                </div>
                                              </div>
                                              <div v-else>
                                                <a
                                                  class="text-dark"
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="showPostDetail(post.id)"
                                                >
                                                  <img
                                                    :src="default_image"
                                                    alt=""
                                                    class="img-thumbnail"
                                                    style="
                                                      height: auto !important;
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                    "
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else></div>
                                          <ul
                                            class="list-inline pt-2"
                                            style="
                                              display: flex;
                                              justify-content: space-between;
                                            "
                                          >
                                            <li class="list-inline-item">
                                              <a
                                                class="text-muted"
                                                href="javascript:void(0)"
                                                @click="getToggelData(post.id)"
                                                ><i
                                                  class="bx bx-like align-middle text-muted me-1"
                                                ></i>
                                                {{
                                                  post.like_users.length +
                                                  post.like_companies.length +
                                                  post.like_admin.length
                                                }}
                                                Likes</a
                                              >
                                            </li>
                                            <li class="list-inline-item">
                                              <a
                                                class="text-muted"
                                                href="#"
                                                v-on:click="isHidden = false"
                                                @click="showPostDetail(post.id)"
                                              >
                                                <i
                                                  class="bx bx-comment-dots align-middle text-muted me-1"
                                                ></i>
                                                {{ post.comments.length }} Comments</a
                                              >
                                            </li>
                                          </ul>
                                        </div>
                                        <div class="pb-3 pt-3 pr-2 pl-2" v-else>
                                          <div v-if="post.repost_id && post.parent_post">
                                            <div class="repost-border pr-2 pl-2">
                                              <a
                                                class="text-dark"
                                                href="#"
                                                v-on:click="isHidden = false"
                                                @click="
                                                  showPostDetail(post.parent_post.id)
                                                "
                                              >
                                                <div class="p-3">
                                                  <div
                                                    style="
                                                      display: flex;
                                                      align-items: center;
                                                      width: 100% !important;
                                                      justify-content: space-between;
                                                    "
                                                  >
                                                    <div
                                                      style="
                                                        display: flex;
                                                        align-items: center;
                                                      "
                                                      v-if="
                                                        post.parent_post.company &&
                                                        post.parent_post.is_company == 1
                                                      "
                                                    >
                                                      <b-avatar
                                                        variant="info"
                                                        :src="
                                                          post.parent_post.company
                                                            .image_url
                                                        "
                                                        class="mr-3"
                                                        v-if="
                                                          post.parent_post.company.image
                                                        "
                                                      ></b-avatar>
                                                      <b-avatar
                                                        variant="info"
                                                        :src="company_image"
                                                        class="mr-3"
                                                        v-else
                                                      ></b-avatar>
                                                      <div style="display: grid">
                                                        <span
                                                          class="font-size-15 mr-auto text-dark"
                                                          >{{
                                                            post.parent_post.company.name
                                                          }}</span
                                                        >
                                                        <small
                                                          v-if="
                                                            post.parent_post.created_at
                                                          "
                                                          class="text-muted"
                                                          >{{
                                                            moment(
                                                              post.parent_post.created_at
                                                            ).fromNow()
                                                          }}
                                                        </small>
                                                        <small v-else class="text-muted"
                                                          >-</small
                                                        >
                                                      </div>
                                                    </div>

                                                    <div
                                                      style="
                                                        display: flex;
                                                        align-items: center;
                                                      "
                                                      v-if="
                                                        post.parent_post.user &&
                                                        post.parent_post.is_company == 0
                                                      "
                                                    >
                                                      <b-avatar
                                                        variant="info"
                                                        :src="
                                                          post.parent_post.user.image_url
                                                        "
                                                        class="mr-3"
                                                        v-if="post.parent_post.user.image"
                                                      ></b-avatar>
                                                      <b-avatar
                                                        variant="info"
                                                        :src="user_image"
                                                        class="mr-3"
                                                        v-else
                                                      ></b-avatar>
                                                      <div style="display: grid">
                                                        <span
                                                          class="font-size-15 mr-auto text-dark"
                                                          >{{
                                                            post.parent_post.user.name
                                                          }}</span
                                                        >

                                                        <small
                                                          v-if="
                                                            post.parent_post.created_at
                                                          "
                                                          class="text-muted"
                                                          >{{
                                                            moment(
                                                              post.parent_post.created_at
                                                            ).fromNow()
                                                          }}</small
                                                        >
                                                        <small v-else class="text-muted"
                                                          >-</small
                                                        >
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="pl-3 pr-3">
                                                  <div
                                                    v-html="
                                                      post.parent_post.post_description
                                                    "
                                                    id="app"
                                                    style="white-space: pre-wrap"
                                                    class="text-dark"
                                                    v-if="
                                                      post.parent_post.post_description
                                                        .length < 500
                                                    "
                                                  ></div>

                                                  <div
                                                    v-html="
                                                      post.parent_post.post_description.substring(
                                                        0,
                                                        500
                                                      ) + '..'
                                                    "
                                                    id="app"
                                                    style="white-space: pre-wrap"
                                                    class="text-dark pt-3"
                                                    v-else
                                                  ></div>
                                                  <div
                                                    v-if="
                                                      post.parent_post.post_description
                                                        .length > 500
                                                    "
                                                    class="mb-2"
                                                  >
                                                    <router-link
                                                      :to="{
                                                        name: 'company.newsfeeds.show',
                                                        params: { id: post.id },
                                                      }"
                                                      class="text-primary"
                                                      >Read more
                                                      <i class="mdi mdi-arrow-right"></i
                                                    ></router-link>
                                                  </div>

                                                  <div
                                                    v-if="
                                                      post.parent_post.website_url ||
                                                      post.parent_post.posts_images
                                                        .length > 0
                                                    "
                                                  >
                                                    <div
                                                      class="position-relative mb-3 mt-3"
                                                      v-if="post.parent_post.website_url"
                                                    >
                                                      <div class="repost-border1">
                                                        <a
                                                          :href="
                                                            post.parent_post.website_url
                                                          "
                                                          class="text-primary"
                                                          target="_blank"
                                                        >
                                                          <div
                                                            class=""
                                                            style="width: 100% !important"
                                                          >
                                                            <div
                                                              style="
                                                                display: flex;
                                                                align-items: center;
                                                                width: 100% !important;
                                                                justify-content: space-between;
                                                              "
                                                            >
                                                              <div
                                                                style="
                                                                  display: flex;
                                                                  align-items: center;
                                                                "
                                                              >
                                                                <img
                                                                  :src="
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_image
                                                                  "
                                                                  alt=""
                                                                  v-if="
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_image
                                                                  "
                                                                  style="
                                                                    width: 100% !important;
                                                                    object-fit: cover;
                                                                  "
                                                                  @error="
                                                                    companyimageNotFound
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                            <div
                                                              style="
                                                                background-color: #e8e8e8;
                                                                width: 100% !important;
                                                                object-fit: cover;
                                                                padding: 10px;
                                                              "
                                                            >
                                                              <span
                                                                style="color: #000"
                                                                class="text-dark"
                                                                v-if="
                                                                  post.parent_post
                                                                    .website_detail
                                                                    .website_title
                                                                "
                                                              >
                                                                <h6>
                                                                  {{
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_title
                                                                  }}
                                                                </h6>
                                                              </span>
                                                              <span
                                                                style="color: #000"
                                                                class="text-dark"
                                                                v-if="
                                                                  post.parent_post
                                                                    .website_detail
                                                                    .website_description
                                                                "
                                                              >
                                                                {{
                                                                  post.parent_post
                                                                    .website_detail
                                                                    .website_description
                                                                }}
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </a>
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="position-relative mb-3 mt-3"
                                                      v-else
                                                    >
                                                      <div
                                                        v-if="
                                                          post.parent_post.posts_images
                                                            .length > 1
                                                        "
                                                      >
                                                        <slider
                                                          animation="fade"
                                                          height="400px"
                                                          width="auto"
                                                        >
                                                          <slider-item
                                                            v-for="(image, index) in post
                                                              .parent_post.posts_images"
                                                            :key="index"
                                                          >
                                                            <img
                                                              :src="
                                                                image.image_path +
                                                                '/' +
                                                                image.image
                                                              "
                                                              width="665px;"
                                                              style="
                                                                height: 400px !important;
                                                              "
                                                              @error="imageNotFound"
                                                            />
                                                          </slider-item>
                                                        </slider>
                                                      </div>
                                                      <div
                                                        v-else-if="
                                                          post.parent_post.posts_images
                                                            .length == 1
                                                        "
                                                      >
                                                        <video
                                                          style="
                                                            height: auto !important;
                                                            width: 100% !important;
                                                            object-fit: cover;
                                                          "
                                                          v-if="
                                                            post.parent_post
                                                              .posts_images[0].type ==
                                                            'Video'
                                                          "
                                                          controls
                                                          :src="
                                                            post.parent_post
                                                              .posts_images[0]
                                                              .image_path +
                                                            '/' +
                                                            post.parent_post
                                                              .posts_images[0].image
                                                          "
                                                        ></video>

                                                        <img
                                                          :src="
                                                            post.parent_post
                                                              .posts_images[0]
                                                              .image_path +
                                                            '/' +
                                                            post.parent_post
                                                              .posts_images[0].image
                                                          "
                                                          alt=""
                                                          v-if="
                                                            post.parent_post
                                                              .posts_images[0].type ==
                                                            'Image'
                                                          "
                                                          class="img-thumbnail"
                                                          width="100%"
                                                          @error="imageNotFound"
                                                        />
                                                        <!-- style="
                                                            height: 400px !important;
                                                            width: 100% !important;
                                                          " -->
                                                        <div
                                                          class="embed-responsive embed-responsive-16by9"
                                                          v-if="
                                                            post.parent_post
                                                              .posts_images[0].type ==
                                                            'File'
                                                          "
                                                        >
                                                          <iframe
                                                            class="embed-responsive-item vue_frame"
                                                            :src="
                                                              post.parent_post
                                                                .posts_images[0]
                                                                .image_path +
                                                              '/' +
                                                              post.parent_post
                                                                .posts_images[0].image
                                                            "
                                                          ></iframe>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div v-else></div>
                                                  <ul
                                                    class="list-inline"
                                                    style="
                                                      display: flex;
                                                      justify-content: space-between;
                                                    "
                                                  >
                                                    <li class="list-inline-item">
                                                      <i
                                                        class="bx bx-like align-middle text-muted me-1"
                                                      ></i>
                                                      {{
                                                        post.parent_post.like_admin
                                                          .length +
                                                        post.parent_post.like_companies
                                                          .length +
                                                        post.parent_post.like_users.length
                                                      }}
                                                      Likes
                                                    </li>
                                                    <li class="list-inline-item">
                                                      <i
                                                        class="bx bx-comment-dots align-middle text-muted me-1"
                                                      ></i>
                                                      {{
                                                        post.parent_post.comments.length
                                                      }}
                                                      Comments
                                                    </li>
                                                  </ul>
                                                </div>
                                              </a>
                                            </div>
                                            <ul
                                              class="list-inline pt-3"
                                              style="
                                                display: flex;
                                                justify-content: space-between;
                                              "
                                            >
                                              <li class="list-inline-item">
                                                <a
                                                  class="text-muted"
                                                  href="javascript:void(0)"
                                                  @click="getToggelData(post.id)"
                                                  ><i
                                                    class="bx bx-like align-middle text-muted me-1"
                                                  ></i>
                                                  {{
                                                    post.like_users.length +
                                                    post.like_companies.length +
                                                    post.like_admin.length
                                                  }}
                                                  Likes</a
                                                >
                                              </li>
                                              <li class="list-inline-item">
                                                <router-link
                                                  :to="{
                                                    name: 'post.show',
                                                    params: { id: post.id },
                                                  }"
                                                  class="text-muted"
                                                >
                                                  <i
                                                    class="bx bx-comment-dots align-middle text-muted me-1"
                                                  ></i>
                                                  {{ post.comments.length }} Comments
                                                </router-link>

                                                <!-- <a class="text-muted" href="/blog-list"
                                ><i
                                  class="bx bx-comment-dots align-middle text-muted me-1"
                                ></i>
                                {{ post.comment_count }} Comments</a
                              > -->
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <hr class="my-1" />
                                        <div class="pl-3 pr-3 pt-2">
                                          <ul
                                            class="list-inline text-muted"
                                            style="
                                              display: flex;
                                              justify-content: space-between;
                                            "
                                          >
                                            <li
                                              class="list-inline-item w-50 likes-post"
                                              v-if="post.like_admin.length > 0"
                                              style="text-align: center"
                                            >
                                              <a
                                                @click="likes(post.id)"
                                                class="text-muted"
                                                href="javascript:void(0)"
                                              >
                                                <i
                                                  class="bx bxs-like align-middle text-muted me-1 bx-sm"
                                                ></i>
                                              </a>
                                            </li>
                                            <li
                                              class="list-inline-item w-50 likes-post"
                                              v-else
                                              style="text-align: center"
                                            >
                                              <a
                                                @click="likes(post.id)"
                                                class="text-muted"
                                                href="javascript:void(0)"
                                              >
                                                <i
                                                  class="bx bx-like align-middle text-muted me-1 bx-sm"
                                                ></i>
                                              </a>
                                            </li>

                                            <li
                                              class="list-inline-item w-50"
                                              style="text-align: center"
                                            >
                                              <a
                                                href="#"
                                                v-on:click="isHidden = false"
                                                @click="comments(post.id)"
                                                class="text-muted"
                                              >
                                                <i
                                                  class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                                                ></i>
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                        <hr class="mb-5" v-if="posts.data.length > 1" />
                                      </div>
                                      <br />
                                    </div>
                                    <div class="text-center">
                                      <ul
                                        class="pagination justify-content-center pagination-rounded"
                                      >
                                        <pagination
                                          :data="paginations"
                                          :limit="limit"
                                          @pagination-change-page="post"
                                        ></pagination>
                                      </ul>
                                    </div>
                                  </div>

                                  <div v-else class="justify-content-center row">
                                    <label class="align-middle">No posts yet</label>
                                  </div>

                                  <hr class="my-4" />
                                </div>
                              </div>
                            </div>
                            <div class="justify-content-center row" v-else>
                              <div class="col-xl-11">
                                <div>
                                  <div class="text-left">
                                    <div class="row">
                                      <div class="text-left mb-2">
                                        <a
                                          href="#"
                                          class="router-link-active"
                                          @click="hideData"
                                        >
                                          <i class="bx bx-arrow-back"></i>

                                          Back
                                        </a>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div
                                        style="
                                          display: flex;
                                          align-items: center;
                                          width: 100% !important;
                                          justify-content: space-between;
                                        "
                                      >
                                        <div style="display: flex; align-items: center">
                                          <b-avatar
                                            variant="info"
                                            :src="
                                              postDetail.company.image_path +
                                              '/' +
                                              postDetail.company.image
                                            "
                                            class="mr-3"
                                            v-if="postDetail.company.image"
                                          ></b-avatar>
                                          <b-avatar
                                            variant="info"
                                            :src="company_image"
                                            class="mr-3"
                                            v-else
                                          ></b-avatar>

                                          <div style="display: grid">
                                            <span class="font-size-18 mr-auto"
                                              >{{ postDetail.company.name }}
                                            </span>

                                            <small
                                              v-if="postDetail.created"
                                              class="text-muted"
                                              >{{
                                                moment(postDetail.created).fromNow()
                                              }}</small
                                            >
                                            <small v-else class="text-muted">-</small>
                                          </div>
                                        </div>
                                        <b-dropdown
                                          class="float-right ml-5"
                                          toggle-class="text-muted p-0"
                                          right
                                          variant="white"
                                        >
                                          <template v-slot:button-content>
                                            <i
                                              class="mdi mdi-dots-horizontal font-size-18"
                                            ></i>
                                          </template>
                                          <b-dropdown-item
                                            @click="editPostName(postDetail.id)"
                                            v-if="!post.repost_id && !post.parent_post"
                                            >Edit</b-dropdown-item
                                          >
                                          <b-dropdown-item
                                            @click="deletePostName(postDetail.id)"
                                            >Delete</b-dropdown-item
                                          >
                                        </b-dropdown>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="mb-4 me-4">
                                    <input type="hidden" :value="postDetail.id" />

                                    <div v-if="!postDetail.repost_id">
                                      <div
                                        v-html="postDetail.post_description"
                                        id="app"
                                        style="white-space: pre-wrap"
                                        class="text-muted font-size-14 mt-3"
                                      ></div>

                                      <div
                                        v-if="
                                          postDetail.website_url ||
                                          postDetail.posts_images.length > 0
                                        "
                                      >
                                        <div
                                          class="position-relative mb-3 mt-3"
                                          v-if="postDetail.website_url"
                                        >
                                          <!-- <a
                                            :href="postDetail.website_url"
                                            class="text-primary"
                                            target="_blank"
                                            >{{ postDetail.website_url }}</a
                                          > -->

                                          <div class="repost-border1">
                                            <a
                                              :href="
                                                postDetail.website_detail.website_url
                                              "
                                              class="text-primary"
                                              target="_blank"
                                            >
                                              <div
                                                class=""
                                                style="width: 100% !important"
                                              >
                                                <div
                                                  style="
                                                    display: flex;
                                                    align-items: center;
                                                    width: 100% !important;
                                                    justify-content: space-between;
                                                  "
                                                >
                                                  <div
                                                    style="
                                                      display: flex;
                                                      align-items: center;
                                                    "
                                                  >
                                                    <img
                                                      :src="
                                                        postDetail.website_detail
                                                          .website_image
                                                      "
                                                      alt=""
                                                      v-if="
                                                        postDetail.website_detail
                                                          .website_image
                                                      "
                                                      style="
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                      "
                                                      @error="companyimageNotFound"
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  style="
                                                    background-color: #e8e8e8;
                                                    width: 100% !important;
                                                    object-fit: cover;
                                                    padding: 10px;
                                                  "
                                                >
                                                  <span
                                                    style="color: #000"
                                                    class="text-dark"
                                                    v-if="
                                                      postDetail.website_detail
                                                        .website_title
                                                    "
                                                  >
                                                    <h6>
                                                      {{
                                                        postDetail.website_detail
                                                          .website_title
                                                      }}
                                                    </h6>
                                                  </span>
                                                  <span
                                                    style="color: #000"
                                                    class="text-dark"
                                                    v-if="
                                                      postDetail.website_detail
                                                        .website_description
                                                    "
                                                  >
                                                    {{
                                                      postDetail.website_detail
                                                        .website_description
                                                    }}
                                                  </span>
                                                </div>
                                              </div>
                                            </a>
                                          </div>
                                        </div>
                                        <div v-else>
                                          <div v-if="postDetail.posts_images.length > 1">
                                            <slider
                                              animation="fade"
                                              style="width: 100% !important"
                                            >
                                              <slider-item
                                                v-for="index in postDetail.posts_images"
                                                :key="index"
                                              >
                                                <img
                                                  :src="
                                                    index.image_path + '/' + index.image
                                                  "
                                                  style="
                                                    height: 300px !important;
                                                    width: 100% !important;
                                                    object-fit: cover;
                                                  "
                                                  @error="imageNotFound"
                                                />
                                              </slider-item>
                                            </slider>
                                          </div>
                                          <div
                                            v-else-if="
                                              postDetail.posts_images.length == 1
                                            "
                                          >
                                            <img
                                              v-if="
                                                postDetail.posts_images[0].type == 'Image'
                                              "
                                              :src="
                                                postDetail.posts_images[0].image_path +
                                                '/' +
                                                postDetail.posts_images[0].image
                                              "
                                              alt=""
                                              class="img-thumbnail"
                                              style="
                                                height: auto !important;
                                                width: 100% !important;
                                                object-fit: cover;
                                              "
                                              @error="imageNotFound"
                                            />
                                            <video
                                              style="
                                                height: auto !important;
                                                width: 100% !important;
                                                object-fit: cover;
                                              "
                                              v-if="
                                                postDetail.posts_images[0].type == 'Video'
                                              "
                                              controls
                                              :src="
                                                postDetail.posts_images[0].image_path +
                                                '/' +
                                                postDetail.posts_images[0].image
                                              "
                                            ></video>
                                            <div
                                              class="embed-responsive embed-responsive-16by9"
                                              v-if="
                                                postDetail.posts_images[0].type == 'File'
                                              "
                                              style="margin-bottom: -115px !important"
                                            >
                                              <iframe
                                                class="embed-responsive-item vue_frame"
                                                :src="
                                                  postDetail.posts_images[0].image_path +
                                                  '/' +
                                                  postDetail.posts_images[0].image
                                                "
                                              ></iframe>
                                            </div>

                                            <!-- <span
                                              class="pl-2"
                                              v-if="
                                                postDetail.posts_images[0].type == 'File'
                                              "
                                              >{{ postDetail.posts_images[0].image }}</span
                                            > -->
                                          </div>
                                          <div v-else>
                                            <img
                                              :src="default_image"
                                              alt=""
                                              class="img-thumbnail"
                                              style="
                                                height: auto !important;
                                                width: 100% !important;
                                                object-fit: cover;
                                              "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div v-else></div>
                                      <hr />
                                      <div class="mt-3 text-muted font-size-14">
                                        <ul
                                          class="list-inline"
                                          style="
                                            display: flex;
                                            justify-content: space-between;
                                          "
                                        >
                                          <li class="list-inline-item">
                                            <a
                                              class="text-muted"
                                              href="javascript:void(0)"
                                              @click="getToggelData(postDetail.id)"
                                            >
                                              <i
                                                class="bx bx-like align-middle text-muted me-1"
                                              ></i>
                                              {{
                                                postDetail.like_users.length +
                                                postDetail.like_companies.length +
                                                postDetail.like_admin.length
                                              }}
                                              Likes
                                            </a>
                                          </li>
                                          <li class="list-inline-item">
                                            <i
                                              class="bx bx-comment-dots align-middle text-muted me-1"
                                            ></i>
                                            {{ postDetail.comments.length }} Comments
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="pb-3 pt-3 pr-2 pl-2" v-else>
                                      <div
                                        v-if="
                                          postDetail.repost_id && postDetail.parent_post
                                        "
                                      >
                                        <div class="repost-border pr-2 pl-2">
                                          <a
                                            class="text-dark"
                                            href="#"
                                            v-on:click="isHidden = false"
                                            @click="
                                              showPostDetail(postDetail.parent_post.id)
                                            "
                                          >
                                            <div class="p-3">
                                              <div
                                                style="
                                                  display: flex;
                                                  align-items: center;
                                                  width: 100% !important;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <div
                                                  style="
                                                    display: flex;
                                                    align-items: center;
                                                  "
                                                  v-if="
                                                    postDetail.parent_post.company &&
                                                    postDetail.parent_post.is_company == 1
                                                  "
                                                >
                                                  <b-avatar
                                                    variant="info"
                                                    :src="
                                                      postDetail.parent_post.company
                                                        .image_url
                                                    "
                                                    class="mr-3"
                                                    v-if="
                                                      postDetail.parent_post.company.image
                                                    "
                                                  ></b-avatar>
                                                  <b-avatar
                                                    variant="info"
                                                    :src="company_image"
                                                    class="mr-3"
                                                    v-else
                                                  ></b-avatar>
                                                  <div style="display: grid">
                                                    <span
                                                      class="font-size-15 mr-auto text-dark"
                                                      >{{
                                                        postDetail.parent_post.company
                                                          .name
                                                      }}</span
                                                    >
                                                    <small
                                                      v-if="
                                                        postDetail.parent_post.created_at
                                                      "
                                                      class="text-muted"
                                                      >{{
                                                        moment(
                                                          postDetail.parent_post
                                                            .created_at
                                                        ).fromNow()
                                                      }}
                                                    </small>
                                                    <small v-else class="text-muted"
                                                      >-</small
                                                    >
                                                  </div>
                                                </div>

                                                <div
                                                  style="
                                                    display: flex;
                                                    align-items: center;
                                                  "
                                                  v-if="
                                                    postDetail.parent_post.user &&
                                                    postDetail.parent_post.is_company == 0
                                                  "
                                                >
                                                  <b-avatar
                                                    variant="info"
                                                    :src="
                                                      postDetail.parent_post.user
                                                        .image_url
                                                    "
                                                    class="mr-3"
                                                    v-if="
                                                      postDetail.parent_post.user.image
                                                    "
                                                  ></b-avatar>
                                                  <b-avatar
                                                    variant="info"
                                                    :src="user_image"
                                                    class="mr-3"
                                                    v-else
                                                  ></b-avatar>
                                                  <div style="display: grid">
                                                    <span
                                                      class="font-size-15 mr-auto text-dark"
                                                      >{{
                                                        postDetail.parent_post.user.name
                                                      }}</span
                                                    >

                                                    <small
                                                      v-if="
                                                        postDetail.parent_post.created_at
                                                      "
                                                      class="text-muted"
                                                      >{{
                                                        moment(
                                                          postDetail.parent_post
                                                            .created_at
                                                        ).fromNow()
                                                      }}</small
                                                    >
                                                    <small v-else class="text-muted"
                                                      >-</small
                                                    >
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="pl-3 pr-3">
                                              <div
                                                v-html="
                                                  postDetail.parent_post.post_description
                                                "
                                                id="app"
                                                style="white-space: pre-wrap"
                                                class="text-dark"
                                                v-if="
                                                  postDetail.parent_post.post_description
                                                    .length < 500
                                                "
                                              ></div>

                                              <div
                                                v-html="
                                                  postDetail.parent_post.post_description.substring(
                                                    0,
                                                    500
                                                  ) + '..'
                                                "
                                                id="app"
                                                style="white-space: pre-wrap"
                                                class="text-dark pt-3"
                                                v-else
                                              ></div>
                                              <div
                                                v-if="
                                                  postDetail.parent_post.post_description
                                                    .length > 500
                                                "
                                                class="mb-2"
                                              >
                                                <router-link
                                                  :to="{
                                                    name: 'company.newsfeeds.show',
                                                    params: { id: postDetail.id },
                                                  }"
                                                  class="text-primary"
                                                  >Read more
                                                  <i class="mdi mdi-arrow-right"></i
                                                ></router-link>
                                              </div>

                                              <div
                                                v-if="
                                                  postDetail.parent_post.website_url ||
                                                  postDetail.parent_post.posts_images
                                                    .length > 0
                                                "
                                              >
                                                <div
                                                  class="position-relative mb-3 mt-3"
                                                  v-if="
                                                    postDetail.parent_post.website_url
                                                  "
                                                >
                                                  <div class="repost-border1">
                                                    <a
                                                      :href="
                                                        postDetail.parent_post.website_url
                                                      "
                                                      class="text-primary"
                                                      target="_blank"
                                                    >
                                                      <div
                                                        class=""
                                                        style="width: 100% !important"
                                                      >
                                                        <div
                                                          style="
                                                            display: flex;
                                                            align-items: center;
                                                            width: 100% !important;
                                                            justify-content: space-between;
                                                          "
                                                        >
                                                          <div
                                                            style="
                                                              display: flex;
                                                              align-items: center;
                                                            "
                                                          >
                                                            <img
                                                              :src="
                                                                postDetail.parent_post
                                                                  .website_detail
                                                                  .website_image
                                                              "
                                                              alt=""
                                                              v-if="
                                                                postDetail.parent_post
                                                                  .website_detail
                                                                  .website_image
                                                              "
                                                              style="
                                                                width: 100% !important;
                                                                object-fit: cover;
                                                              "
                                                              @error="
                                                                companyimageNotFound
                                                              "
                                                            />
                                                          </div>
                                                        </div>
                                                        <div
                                                          style="
                                                            background-color: #e8e8e8;
                                                            width: 100% !important;
                                                            object-fit: cover;
                                                            padding: 10px;
                                                          "
                                                        >
                                                          <span
                                                            style="color: #000"
                                                            class="text-dark"
                                                            v-if="
                                                              postDetail.parent_post
                                                                .website_detail
                                                                .website_title
                                                            "
                                                          >
                                                            <h6>
                                                              {{
                                                                postDetail.parent_post
                                                                  .website_detail
                                                                  .website_title
                                                              }}
                                                            </h6>
                                                          </span>
                                                          <span
                                                            style="color: #000"
                                                            class="text-dark"
                                                            v-if="
                                                              postDetail.parent_post
                                                                .website_detail
                                                                .website_description
                                                            "
                                                          >
                                                            {{
                                                              postDetail.parent_post
                                                                .website_detail
                                                                .website_description
                                                            }}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </a>
                                                  </div>
                                                </div>
                                                <div
                                                  class="position-relative mb-3 mt-3"
                                                  v-else
                                                >
                                                  <div
                                                    v-if="
                                                      postDetail.parent_post.posts_images
                                                        .length > 1
                                                    "
                                                  >
                                                    <slider
                                                      animation="fade"
                                                      height="400px"
                                                      width="auto"
                                                    >
                                                      <slider-item
                                                        v-for="(
                                                          image, index
                                                        ) in postDetail.parent_post
                                                          .posts_images"
                                                        :key="index"
                                                      >
                                                        <img
                                                          :src="
                                                            image.image_path +
                                                            '/' +
                                                            image.image
                                                          "
                                                          width="665px;"
                                                          style="height: 400px !important"
                                                          @error="imageNotFound"
                                                        />
                                                      </slider-item>
                                                    </slider>
                                                  </div>
                                                  <div
                                                    v-else-if="
                                                      postDetail.parent_post.posts_images
                                                        .length == 1
                                                    "
                                                  >
                                                    <video
                                                      style="
                                                        height: auto !important;
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                      "
                                                      v-if="
                                                        postDetail.parent_post
                                                          .posts_images[0].type == 'Video'
                                                      "
                                                      controls
                                                      :src="
                                                        postDetail.parent_post
                                                          .posts_images[0].image_path +
                                                        '/' +
                                                        postDetail.parent_post
                                                          .posts_images[0].image
                                                      "
                                                    ></video>

                                                    <img
                                                      :src="
                                                        postDetail.parent_post
                                                          .posts_images[0].image_path +
                                                        '/' +
                                                        postDetail.parent_post
                                                          .posts_images[0].image
                                                      "
                                                      alt=""
                                                      v-if="
                                                        postDetail.parent_post
                                                          .posts_images[0].type == 'Image'
                                                      "
                                                      class="img-thumbnail"
                                                      width="100%"
                                                      @error="imageNotFound"
                                                    />
                                                    <!-- style="
                                                        height: 400px !important;
                                                        width: 100% !important;
                                                      " -->
                                                    <div
                                                      class="embed-responsive embed-responsive-16by9"
                                                      v-if="
                                                        postDetail.parent_post
                                                          .posts_images[0].type == 'File'
                                                      "
                                                    >
                                                      <iframe
                                                        class="embed-responsive-item vue_frame"
                                                        :src="
                                                          postDetail.parent_post
                                                            .posts_images[0].image_path +
                                                          '/' +
                                                          postDetail.parent_post
                                                            .posts_images[0].image
                                                        "
                                                      ></iframe>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div v-else></div>
                                              <ul
                                                class="list-inline"
                                                style="
                                                  display: flex;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <li class="list-inline-item">
                                                  <i
                                                    class="bx bx-like align-middle text-muted me-1"
                                                  ></i>
                                                  {{
                                                    postDetail.parent_post.like_admin
                                                      .length +
                                                    postDetail.parent_post.like_companies
                                                      .length +
                                                    postDetail.parent_post.like_users
                                                      .length
                                                  }}
                                                  Likes
                                                </li>
                                                <li class="list-inline-item">
                                                  <i
                                                    class="bx bx-comment-dots align-middle text-muted me-1"
                                                  ></i>
                                                  {{
                                                    postDetail.parent_post.comments.length
                                                  }}
                                                  Comments
                                                </li>
                                              </ul>
                                            </div>
                                          </a>
                                        </div>
                                        <ul
                                          class="list-inline pt-3"
                                          style="
                                            display: flex;
                                            justify-content: space-between;
                                          "
                                        >
                                          <li class="list-inline-item">
                                            <a
                                              class="text-muted"
                                              href="javascript:void(0)"
                                              @click="getToggelData(postDetail.id)"
                                              ><i
                                                class="bx bx-like align-middle text-muted me-1"
                                              ></i>
                                              {{
                                                postDetail.like_users.length +
                                                postDetail.like_companies.length +
                                                postDetail.like_admin.length
                                              }}
                                              Likes</a
                                            >
                                          </li>
                                          <li class="list-inline-item">
                                            <router-link
                                              :to="{
                                                name: 'post.show',
                                                params: { id: postDetail.id },
                                              }"
                                              class="text-muted"
                                            >
                                              <i
                                                class="bx bx-comment-dots align-middle text-muted me-1"
                                              ></i>
                                              {{ postDetail.comments.length }} Comments
                                            </router-link>

                                            <!-- <a class="text-muted" href="/blog-list"
                                ><i
                                  class="bx bx-comment-dots align-middle text-muted me-1"
                                ></i>
                                {{ post.comment_count }} Comments</a
                              > -->
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <hr class="my-1" />
                                    <div class="pl-3 pr-3 pt-2">
                                      <ul
                                        class="list-inline text-muted"
                                        style="
                                          display: flex;
                                          justify-content: space-between;
                                        "
                                      >
                                        <li
                                          class="list-inline-item w-50 likes-post"
                                          v-if="postDetail.like_admin.length > 0"
                                          style="text-align: center"
                                        >
                                          <a
                                            @click="likes(postDetail.id)"
                                            class="text-muted"
                                            href="javascript:void(0)"
                                          >
                                            <i
                                              class="bx bxs-like align-middle text-muted me-1 bx-sm"
                                            ></i>
                                          </a>
                                        </li>
                                        <li
                                          class="list-inline-item w-50 likes-post"
                                          v-else
                                          style="text-align: center"
                                        >
                                          <a
                                            @click="likes(postDetail.id)"
                                            class="text-muted"
                                            href="javascript:void(0)"
                                          >
                                            <i
                                              class="bx bx-like align-middle text-muted me-1 bx-sm"
                                            ></i>
                                          </a>
                                        </li>

                                        <li
                                          class="list-inline-item w-50"
                                          style="text-align: center"
                                        >
                                          <a
                                            @click="comments(postDetail.id)"
                                            class="text-muted"
                                            href="javascript:void(0)"
                                          >
                                            <i
                                              class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                                            ></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  <div class="">
                                    <hr />
                                    <div class="mt-5">
                                      <h5 class="font-size-15">
                                        <i
                                          class="bx bx-message-dots text-muted align-middle me-1"
                                        ></i>
                                        Comments :
                                      </h5>
                                      <div v-if="postDetail.comments.length > 0">
                                        <div
                                          v-for="comment in postDetail.comments"
                                          :key="comment.id"
                                        >
                                          <div class="media py-3">
                                            <div class="avatar-xs me-3">
                                              <div
                                                class="avatar-title rounded-circle bg-light text-primary"
                                              >
                                                <img
                                                  v-if="comment.image"
                                                  :src="url + comment.image"
                                                  alt=""
                                                  class="img-thumbnail"
                                                />
                                                <img
                                                  v-else
                                                  :src="default_image"
                                                  alt=""
                                                  class="img-thumbnail"
                                                />
                                              </div>
                                            </div>

                                            <div class="media-body">
                                              <h5
                                                class="font-size-14 mb-1"
                                                style="margin-left: 10px"
                                              >
                                                {{ comment.name }}
                                                <small class="text-muted float-end">{{
                                                  moment(comment.created_at).fromNow()
                                                }}</small>
                                              </h5>
                                              <br />
                                              <p class="text-muted ml-3">
                                                {{ comment.comment }}
                                              </p>

                                              <!-- <div>
                                                <a
                                                  class="text-success"
                                                  href="/blog-details"
                                                >
                                                  <i class="mdi mdi-reply"></i> Reply
                                                </a>
                                              </div> -->
                                              <div
                                                class="media border-top"
                                                style="
                                                  margin-bottom: -16px;
                                                  margin-top: 18px;
                                                "
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div v-else class="justify-content-center row">
                                        <label class="align-middle mt-2"
                                          >No comments yet</label
                                        >
                                      </div>
                                    </div>

                                    <div class="mt-4" v-if="commentSeen">
                                      <h5 class="font-size-16 mb-3">Leave a Message</h5>
                                      <form @submit.prevent="create(postDetail.id)">
                                        <div class="mb-3 mb-3">
                                          <label
                                            for="commentmessage-input"
                                            class="form-label form-label"
                                            >Message</label
                                          ><textarea
                                            class="form-control"
                                            id="commentmessage-input"
                                            placeholder="Your message..."
                                            rows="3"
                                            v-model="commentData.comment"
                                          ></textarea>
                                        </div>
                                        <div class="text-end">
                                          <button
                                            type="submit"
                                            class="btn btn-success w-sm"
                                            :disabled="isActive"
                                          >
                                            Submit
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <b-sidebar
                              id="sidebar-rigth"
                              title="Likes"
                              right
                              :visible="showSidebar"
                              ref="mySidebar"
                              backdrop
                              shadow
                              @hidden="showSidebar = false"
                            >
                              <div class="px-3 py-2">
                                <b-tabs pills fill content-class="my-4">
                                  <b-card-text>
                                    <div>
                                      <h5 class="font-size-14 mb-3">Users</h5>
                                      <div style="max-height: 410px">
                                        <ul class="list-unstyled chat-list">
                                          <li
                                            class
                                            v-for="data of like_users"
                                            :key="data.id"
                                          >
                                            <a href="javascript: void(0);">
                                              <div class="media">
                                                <div
                                                  class="mr-3"
                                                  v-if="data.role_id == '2'"
                                                >
                                                  <img
                                                    :src="
                                                      data.image_path + '/' + data.image
                                                    "
                                                    class="rounded-circle avatar-xs"
                                                    style="height:40px; !important; width:40px !important"
                                                    alt
                                                    v-if="data.image"
                                                    @error="companyimageNotFound"
                                                  />
                                                  <img
                                                    :src="company_image"
                                                    class="rounded-circle avatar-xs"
                                                    style="height:40px; !important; width:40px !important"
                                                    alt
                                                    v-else
                                                  />
                                                </div>
                                                <div class="mr-3" v-else>
                                                  <img
                                                    :src="
                                                      data.image_path + '/' + data.image
                                                    "
                                                    class="rounded-circle avatar-xs"
                                                    style="height:40px; !important; width:40px !important"
                                                    alt
                                                    v-if="data.image"
                                                    @error="userimageNotFound"
                                                  />
                                                  <img
                                                    :src="user_image"
                                                    class="rounded-circle avatar-xs"
                                                    style="height:40px; !important; width:40px !important"
                                                    alt
                                                    v-else
                                                  />
                                                </div>
                                                <div class="media-body overflow-hidden">
                                                  <h5
                                                    class="text-truncate font-size-14"
                                                    style="
                                                      margin-bottom: 0.1px !important;
                                                    "
                                                  >
                                                    {{ data.name }}
                                                  </h5>
                                                  <span
                                                    class="badge badge-secondary"
                                                    v-if="data.role_id == '2'"
                                                    >company</span
                                                  >
                                                  <span
                                                    class="badge badge-secondary"
                                                    v-else
                                                    >user</span
                                                  >
                                                  <p class="text-truncate mb-0">
                                                    {{ data.email }}
                                                  </p>
                                                </div>
                                                <div class="font-size-11 text-muted">
                                                  {{
                                                    moment(
                                                      data["pivot"]["created_at"]
                                                    ).fromNow()
                                                  }}
                                                </div>
                                              </div>
                                            </a>
                                            <hr class="mt-1 mb-1" />
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </b-card-text>
                                </b-tabs>
                              </div>
                            </b-sidebar>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Events" @click="event">
                    <div class="row list-table-main">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="row">
                              <div
                                class="col-12 table-main-list customer-table table-responsive"
                              >
                                <b-table
                                  :items="events"
                                  :fields="eventsData"
                                  :busy="loading"
                                  show-empty
                                >
                                  <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                      <b-spinner class="align-middle"></b-spinner>
                                      <strong>{{ $t("loadingData") }}</strong>
                                    </div>
                                  </template>
                                  <template v-slot:cell(id)="eventData">
                                    <h5 class="font-size-14">
                                      {{ eventData.item.id }}
                                    </h5>
                                  </template>
                                  <template v-slot:cell(name)="eventData">
                                    <div class="d-flex">
                                      <b-avatar
                                        v-if="eventData.item.events_images.length > 0"
                                        variant="info"
                                        :src="
                                          eventData.item.events_images[0].image_path +
                                          '/' +
                                          eventData.item.events_images[0].image
                                        "
                                        class="mr-3"
                                      >
                                      </b-avatar>
                                      <b-avatar
                                        v-else
                                        variant="info"
                                        :src="default_image"
                                        class="mr-3"
                                      >
                                      </b-avatar>
                                      <div>
                                        <span class="font-size-15 mr-auto"
                                          >{{ eventData.item.name }}
                                        </span>
                                        <small class="text-primary">{{
                                          eventData.item.type
                                            ? "(" + eventData.item.type + ")"
                                            : ""
                                        }}</small>
                                        <br />
                                        <small class="text-secondary">{{
                                          eventData.item.start + "-" + eventData.item.end
                                        }}</small>
                                      </div>
                                    </div>
                                  </template>

                                  <template v-slot:cell(is_active)="eventData">
                                    <div
                                      v-if="eventData.item.is_active == '1'"
                                      class="badge badge-pill badge-soft-success font-size-12 mt-2"
                                    >
                                      Active
                                    </div>
                                    <div
                                      v-else
                                      class="badge badge-pill badge-soft-danger font-size-12 mt-2"
                                    >
                                      InActive
                                    </div>
                                  </template>

                                  <template #empty>
                                    <p class="text-center">No events yet</p>
                                  </template>
                                </b-table>
                              </div>
                              <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                  <div
                                    class="dataTables_paginate paging_simple_numbers float-right"
                                  >
                                    <ul class="pagination pagination-rounded mb-0">
                                      <pagination
                                        :data="paginations"
                                        :limit="limit"
                                        @pagination-change-page="event"
                                      ></pagination>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab
                    :title="
                      'Followers' + (followerCount == '' ? '' : '(' + followerCount + ')')
                    "
                    @click="follower"
                  >
                    <div class="row list-table-main">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="row">
                              <div
                                class="col-12 table-main-list customer-table table-responsive"
                              >
                                <b-table
                                  :items="followers"
                                  :fields="eventsData"
                                  :busy="loading"
                                  show-empty
                                >
                                  <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                      <b-spinner class="align-middle"></b-spinner>
                                      <strong>{{ $t("loadingData") }}</strong>
                                    </div>
                                  </template>
                                  <template v-slot:cell(id)="eventData">
                                    <h5 class="font-size-14">
                                      <!-- @click="userDetails(eventData.item.id)" -->
                                      {{ eventData.item.id }}
                                    </h5>
                                  </template>
                                  <template v-slot:cell(name)="eventData">
                                    <div class="d-flex">
                                      <!-- @click="userDetails(eventData.item.id)" -->
                                      <b-avatar
                                        v-if="eventData.item.image"
                                        variant="info"
                                        :src="url + '/' + eventData.item.image"
                                        class="mr-3"
                                      >
                                      </b-avatar>
                                      <b-avatar
                                        v-else
                                        variant="info"
                                        :src="user_image"
                                        class="mr-3"
                                      >
                                      </b-avatar>
                                      <div>
                                        <span class="font-size-15 mr-auto"
                                          >{{ eventData.item.name }}
                                        </span>
                                        <small
                                          class="text-muted"
                                          v-if="
                                            eventData.item.country_code &&
                                            eventData.item.phone_number
                                          "
                                          >{{
                                            eventData.item.phone_number
                                              ? "(" +
                                                eventData.item.country_code +
                                                " " +
                                                eventData.item.phone_number +
                                                ")"
                                              : ""
                                          }}</small
                                        >
                                        <br />
                                        <small class="text-muted">{{
                                          eventData.item.email
                                        }}</small>
                                      </div>
                                    </div>
                                  </template>

                                  <template v-slot:cell(is_active)="eventData">
                                    <div @click="userDetails(eventData.item.id)">
                                      <div
                                        v-if="eventData.item.is_active == '1'"
                                        class="badge badge-pill badge-soft-success font-size-12"
                                      >
                                        Active
                                      </div>
                                      <div
                                        v-else
                                        class="badge badge-pill badge-soft-danger font-size-12"
                                      >
                                        InActive
                                      </div>
                                    </div>
                                  </template>

                                  <template #empty>
                                    <p class="text-center">No followers yet</p>
                                  </template>
                                </b-table>
                              </div>
                              <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                  <div
                                    class="dataTables_paginate paging_simple_numbers float-right"
                                  >
                                    <ul class="pagination pagination-rounded mb-0">
                                      <pagination
                                        :data="paginations"
                                        :limit="limit"
                                        @pagination-change-page="follower"
                                      ></pagination>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab title="About">
                    <div v-if="company.about">
                      <!-- <div style="border: 2px solid #495057">
                        <span v-html="company.about" class="m-3"></span>
                      </div> -->
                      <textarea
                        type="text"
                        class="text-muted"
                        style="
                          height: 150px !important;
                          width: 100% !important;
                          padding: 10px !important;
                          border: 1px solid #ced4da;
                        "
                        v-model="company.about"
                        readonly
                      />
                    </div>
                    <div v-else class="justify-content-center row">
                      <p class="text-center mt-3">Nothing to show</p>
                    </div>
                  </b-tab>
                  <b-tab title="Financials" @click="finance" v-if="financeSeen">
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <vue-dropzone
                              id="dropzone"
                              ref="myVueDropzone"
                              :use-custom-slot="true"
                              :options="financeDropzoneOptions"
                              @vdropzone-complete="afterUploadComplete"
                            >
                              <div class="dropzone-custom-content">
                                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                                <h4>Drop files here or click to upload PDF.</h4>
                              </div>
                            </vue-dropzone>
                            <br />
                            <div
                              class="dropzone-previews mt-3"
                              id="file-previews"
                              v-for="finance in financeFiles"
                              :key="finance.id"
                            >
                              <div
                                class="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete card"
                              >
                                <div class="p-2">
                                  <div class="align-items-center row">
                                    <div class="col">
                                      <a
                                        class="text-muted font-weight-bold"
                                        :href="finance.pdf_link"
                                        target="_blank"
                                        >{{ finance.name }}</a
                                      >
                                    </div>
                                    <div class="mr-3">
                                      <button
                                        @click="deleteFinanceFile(finance.id)"
                                        class="btn export-btn"
                                      >
                                        <i
                                          class="fa fa-trash text-danger"
                                          aria-hidden="true"
                                        ></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />
                            <div class="row col-sm-5 offset-sm-7">
                              <div class="col">
                                <div
                                  class="dataTables_paginate paging_simple_numbers float-right"
                                >
                                  <ul class="pagination pagination-rounded mb-0">
                                    <pagination
                                      :data="paginations"
                                      :limit="limit"
                                      @pagination-change-page="finance"
                                    ></pagination>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Publications" @click="publication" v-if="publicationSeen">
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <vue-dropzone
                              id="dropzone"
                              ref="myVueDropzone"
                              :use-custom-slot="true"
                              :options="publicationDropzoneOptions"
                              @vdropzone-complete="afterUploadComplete"
                            >
                              <div class="dropzone-custom-content">
                                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                                <h4>Drop files here or click to upload PDF.</h4>
                              </div>
                            </vue-dropzone>
                            <br />
                            <div
                              class="dropzone-previews mt-3"
                              id="file-previews"
                              v-for="publication in publicationFiles"
                              :key="publication.id"
                            >
                              <div
                                class="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete card"
                              >
                                <div class="p-2">
                                  <div class="align-items-center row">
                                    <div class="col">
                                      <a
                                        class="text-muted font-weight-bold"
                                        :href="publication.pdf_link"
                                        target="_blank"
                                        >{{ publication.name }}</a
                                      >
                                    </div>
                                    <div class="mr-3">
                                      <button
                                        @click="deletePublicationFile(publication.id)"
                                        class="btn export-btn"
                                      >
                                        <i
                                          class="fa fa-trash text-danger"
                                          aria-hidden="true"
                                        ></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />
                            <div class="row col-sm-5 offset-sm-7">
                              <div class="col">
                                <div
                                  class="dataTables_paginate paging_simple_numbers float-right"
                                >
                                  <ul class="pagination pagination-rounded mb-0">
                                    <pagination
                                      :data="paginations"
                                      :limit="limit"
                                      @pagination-change-page="publication"
                                    ></pagination>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Governance" @click="governance">
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <vue-dropzone
                              id="dropzone"
                              ref="myVueDropzone"
                              :use-custom-slot="true"
                              :options="governanceDropzoneOptions"
                              @vdropzone-complete="afterUploadComplete"
                            >
                              <div class="dropzone-custom-content">
                                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                                <h4>Drop files here or click to upload PDF.</h4>
                              </div>
                            </vue-dropzone>
                            <br />
                            <div
                              class="dropzone-previews mt-3"
                              id="file-previews"
                              v-for="governance in governanceFiles"
                              :key="governance.id"
                            >
                              <div
                                class="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete card"
                              >
                                <div class="p-2">
                                  <div class="align-items-center row">
                                    <div class="col">
                                      <a
                                        class="text-muted font-weight-bold"
                                        :href="governance.pdf_link"
                                        target="_blank"
                                        >{{ governance.name }}</a
                                      >
                                    </div>
                                    <div class="mr-3">
                                      <button
                                        @click="deleteGovernanceFile(governance.id)"
                                        class="btn export-btn"
                                      >
                                        <i
                                          class="fa fa-trash text-danger"
                                          aria-hidden="true"
                                        ></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />
                            <div class="row col-sm-5 offset-sm-7">
                              <div class="col">
                                <div
                                  class="dataTables_paginate paging_simple_numbers float-right"
                                >
                                  <ul class="pagination pagination-rounded mb-0">
                                    <pagination
                                      :data="paginations"
                                      :limit="limit"
                                      @pagination-change-page="governance"
                                    ></pagination>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div></div
                  ></b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm">
                    <div class="search-box mr-2 d-inline-block w-100">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control rounded-sm mb-3"
                          id="search"
                          @input="searchData(type)"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Per Page :</label>
                    <select
                      class="custom-select"
                      v-model="perPage"
                      @change="searchData(type)"
                    >
                      <option value="2" selected>2</option>
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Status :</label>
                    <select
                      class="custom-select"
                      v-model="status"
                      @change="searchData(type)"
                    >
                      <option value="">Both</option>
                      <option value="1" selected>Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-12" v-if="isHidden == false">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Report :</label>
                    <div v-if="postDetail.postreport.length > 0">
                      <div
                        class="mt-2"
                        v-for="report in postDetail.postreport"
                        :key="report.id"
                      >
                        <a href="javascript: void(0);" class="media">
                          <img
                            class="d-flex mr-3 rounded-circle"
                            :src="url + '/' + report.image"
                            alt="Generic placeholder image"
                            height="36"
                            v-if="report.image"
                          />
                          <img
                            class="d-flex mr-3 rounded-circle"
                            :src="user_image"
                            alt="Generic placeholder image"
                            height="36"
                            v-else
                          />

                          <div class="media-body chat-user-box">
                            <p class="user-title m-0">{{ report.name }}</p>
                            <p class="text-muted">{{ report.message }}</p>
                          </div>
                          <div class="font-size-11">{{ report.created }}</div>
                        </a>
                      </div>
                    </div>
                    <div class="mt-2" v-else>
                      <span class="align-self-center">no data</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.likes-post:not(:last-child) {
  border-right: 2px solid #e3e4ea !important;
}
.vue_frame {
  height: 250px !important;
}
.repost-border {
  border: 1px solid;
  border-color: #d0d0d0;
}
</style>
